<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Edit Profile</span>
        </h5>
        
      </CCol>
      <div style="clear:both"></div>
      <br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="text-center">
            <img src="../assets/img/avatar.png" style="width: 80px" /> <br />
            <label class="custom-12px mt-2" style="color: #212529;"> Upload Profile Photo </label> <br />
            <label class="custom-10px"> Upload Profile Photo <br />
                PNG max 10mb</label>
          </div>
  
          <br />

          <div class="">
            <label class="custom-font-setting mt-3"> Full Name </label> <br />
            <input type="text" class="border-white-50px custom-font-setting" value="Siti Tirta" />

            <br />

            <label class="custom-font-setting mt-3"> Email </label> <br />
            <input type="text" class="border-white-50px custom-font-setting" value="Sititirtadinar@gmail.com" />

            <br />

            <label class="custom-font-setting mt-3"> Phone Number </label> <br />
            <div class="border-white-50px">
              <div class="card-grey-50px">
                <img src="../assets/img/country.png" style="width: 22px; top: 4px; left: 4px; position: absolute;" />
                <img src="../assets/img/arrowdown.png" style="width: 25px; top: 4px; left: 30px; position: absolute;" />
                <input type="text" class="input-no-border" style="color: #A3A3A3;" value="+1 2345 678 4321" />
              </div>
            </div>
          </div>

          <br /><br /><br /><br /><br /><br />
          
          <CButton type="button" class="button-border-blue text-white mt-4 mb-5" block>Save</CButton>
          <br /><br />
        </div>
      
              
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        //   GoToEdit() {
        //     this.$router.push("/EditProfile");
        //   },
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>